import { COLORS, getColorById } from '@btime/constants'
import { capitalizeAllIfLower } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Relative } from '../../../components/helpers/Position'
import { Text, Title } from '../../../components/presentation/Text'
import { UserAvatar } from '../../../components/presentation/Avatar'
import { getPublicUrl } from '../../../utils/env/env'
import { useEnv } from '../../../utils/contexts/EnvContext'
import { useLoggedUser, useLogout } from '@btime/react-session'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import HeaderPanel from '../../../components/presentation/HeaderPanel'
import Link from '../../../components/actions/Link'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const user = useLoggedUser()

  const userColor = getColorById(user.id)
  const env = useEnv()

  const logout = useLogout()
  const { t } = useTranslation('profiles')

  return (
    <div>
      <Separator weight={8} />
      <HeaderPanel bgImage={getPublicUrl(env, 'bg-circles.png')} bgColor={userColor} />

      <Relative top="-2rem">
        <FlexGrid gutter={0.5} justify="flex-start">
          <Separator weight={12} vertical />
          <UserAvatar size="xlarge" user={user} borderColor={COLORS.white} />
          <Title size="h2" align="center" noMargin>
            {capitalizeAllIfLower(user.name)}
          </Title>

          <FlexCol flex={1}>
            <FlexGrid gutter={0.5} justify="flex-end">
              <Link onClick={logout}>
                <Text color={COLORS.red}>{t('logout')}</Text>
              </Link>
            </FlexGrid>
          </FlexCol>

          <Separator weight={12} vertical />
        </FlexGrid>
      </Relative>
    </div>
  )
}

export default PageHeader
